import { Modal } from "antd";
import React, { ReactNode } from "react";

interface Props {
  title: string;
  children: ReactNode;
  isModalOpen: boolean;
  footer?: ReactNode[] | null;
  handleCancel?: () => void;
  handleOk: () => void;
}
export const CustomModal = ({
  title,
  children,
  isModalOpen,
  footer,
  handleOk,
  handleCancel,
}: Props) => {
  return (
    <Modal
      title={title}
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={footer}
    >
      {children}
    </Modal>
  );
};
